import React, { useState } from 'react';
import { Container, Row, Col, Form, FormGroup, Input, Label, Button } from 'reactstrap'
import { Password, SignIn, EmailAddress, CreateAccount, YourName } from '../../constant';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';

const Register = (props) => {

  const navigate = useNavigate()
  const [togglePassword, setTogglePassword] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState({
    email: '',
    password: '',
    name: ''
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    const bodyData = {
      email: email,
      password: password,
      name: name
    }
    await axios.post(`${process.env.REACT_APP_API_URL}/api/user/register`, bodyData).then(response => {
      toast.success("Conta criada com sucesso!")
      navigate(`${process.env.PUBLIC_URL}/login`)
    }).catch(error => {
      setErrors({
        email: error.response.data.errors.email ? error.response.data.errors.email[0] : '',
        password: error.response.data.errors.password ? error.response.data.errors.password[0] : '',
        name: error.response.data.errors.name ? error.response.data.errors.name[0] : ''
      })
    })
  }

  return (
    <Container fluid={true} className="p-0">
      <Row>
        <Col xs="12">
          <div className="login-card">
            <div>
              <div><a className="logo" href="#javascript"><img className="img-fluid for-light" src={require("../../assets/images/logo/login.png")} alt="looginpage" /><img className="img-fluid for-dark" src={require("../../assets/images/logo/logo_dark.png")} alt="looginpage" /></a></div>
              <div className="login-main">
                <Form className="needs-validation" noValidate="" onSubmit={handleSubmit}>
                  <h4>{"Criar Conta"}</h4>
                  <p>{"Insira suas informações para criar uma conta"}</p>
                  <FormGroup>
                    <Label className="col-form-label pt-0">{YourName}</Label>
                    <Input className="form-control" type="name" required="" placeholder="John Doe" onChange={(e) => setName(e.target.value)} defaultValue={name}/>
                    <span className="font-danger">{errors.name && 'Nome é obrigatório'}</span>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input className="form-control" type="email" required="" placeholder="Test@gmail.com" onChange={(e) => setEmail(e.target.value)} defaultValue={email}/>
                    <span className="font-danger">{errors.email}</span>
                  </FormGroup>
                  <FormGroup>
                    <div className="mb-3 position-relative">
                      <Label className="col-form-label">{Password}</Label>
                      <Input className="form-control" type={togglePassword ? "text" : "password"} onChange={(e) => setPassword(e.target.value)} defaultValue={password}/>
                      <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}><span className={togglePassword ? "" : "show"}></span></div>
                      <span className="font-danger">{errors.password && 'Senha é obrigatória'}</span>
                    </div>
                  </FormGroup>
                  <div className="login-btn mb-0">
                    <Button type="submit" color="primary">{CreateAccount}</Button>
                  </div>
                  <p className="mt-4 mb-0">{"Já tem uma conta?"}<a className="ms-2" href={`${process.env.PUBLIC_URL}/login`}>{SignIn}</a></p>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Register;